export default __webpack_public_path__ + "static/media/rightArrow.f20a9238.svg";